"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInThisSnapCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const BaseInThisSnapCard_module_css_1 = __importDefault(require("./BaseInThisSnapCard.module.css"));
const Icon_1 = require("./Icon");
const Subtitle_1 = require("./Subtitle");
const Title_1 = require("./Title/Title");
const renderMetadata = (name, subtitle, clickableUrl, onClick) => ((0, jsx_runtime_1.jsxs)("div", { className: BaseInThisSnapCard_module_css_1.default.metadata, children: [clickableUrl ? ((0, jsx_runtime_1.jsx)("a", { href: clickableUrl, className: BaseInThisSnapCard_module_css_1.default.clickableStyle, onClick: onClick, children: (0, jsx_runtime_1.jsx)(Title_1.Title, { title: name }) })) : ((0, jsx_runtime_1.jsx)(Title_1.Title, { title: name })), subtitle && (0, jsx_runtime_1.jsx)(Subtitle_1.Subtitle, { subtitle: subtitle })] }));
/**
 BaseInThisSnapCard is the generic component used to render both Music
 and Lens metadata inside a web player.
 */
function BaseInThisSnapCard({ title, subtitle, iconUrl, clickableUrl, onClick, imageAlt, overrideIcon, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: BaseInThisSnapCard_module_css_1.default.footerCard, "data-testid": "footerCardIcon", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconUrl: iconUrl, imageAlt: imageAlt, overrideIcon: overrideIcon }), renderMetadata(title, subtitle, clickableUrl, onClick)] }));
}
exports.BaseInThisSnapCard = BaseInThisSnapCard;
//# sourceMappingURL=BaseInThisSnapCard.js.map